import { useEffect } from "react";
export function match(value, arms, fallback) {
    return fallback === undefined
        // Unfortunately, we haven't found a way to make the TS typesystem to
        // understand that in the case of `fallback === undefined`, `arms` is
        // not a partial map. But it is, as you can see from the two callable
        // signatures above.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ? arms[value]()
        : (arms[value] ?? fallback)();
}
/** CSS Media query for screens with widths ≤ `w` */
export const screenWidthAtMost = (w) => `@media (max-width: ${w}px)`;
/** CSS Media query for screens with widths > `w` */
export const screenWidthAbove = (w) => `@media not all and (max-width: ${w}px)`;
/** Helper to react to clicks outside of the DOM element referred to by `ref`. */
export const useOnOutsideClick = (ref, callback) => {
    useEffect(() => {
        const handler = (event) => {
            const target = event.target;
            if (ref.current && target instanceof Element && !ref.current.contains(target)) {
                callback();
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    });
};
//# sourceMappingURL=util.js.map